module.exports = __webpack_public_path__ + "static/media/paybotic_bw.92f174e9.png";